<template>
  <div class="box">
    <common-title titleName="会员权益" :isAPPShow="true" />
    <div class="member__top" v-if="!(isMini)"></div>
    <tabs v-model="currentIndex" swipeable line-height="0">
      <tab v-for="(item, index) in benefits" :key="index">
        <template #title>
          <div class="benefits__nav">
            <img class="benefits__nav-img" :src="item.icon" alt="">
            <span class="benefits__nav-title">{{ item.title }}</span>
          </div>
        </template>
        <div class="benefits__content" v-html="item.faq"></div>
      </tab>
    </tabs>
    <buy-btn v-if="!(userMemberInfo.level === 30 && activeTab === 30) && showBtn === 2" :userMemberInfo="userMemberInfo"
      :userInfo="userInfo" :activeTab="key" :memberLevelInfo="memberLevelInfo" :generateOrder="generateOrder"
      :openChat="openChat" :showSeniorBtn="activeTab === 30 ? showBtn : 1"
      :showBasicBtn="activeTab === 20 ? showBtn : 1" />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { Tabs, Tab } from 'vant';
import wx from 'weixin-js-sdk';
// eslint-disable-next-line import/no-cycle
import {
  getUserMember, getMemberLevelInfo, reqCombinationlist, reqCombinationDetail, getBasicBenefits, getSeniorBenefits, getClassType,
} from '@/api/member/index';
import BuyBtn from '../member/components/BuyBtn/index.vue';
// eslint-disable-next-line import/no-cycle

export default {
  computed: {
    ...mapState(['userInfo']),
  },
  components: {
    Tabs,
    Tab,
    BuyBtn,
  },
  data() {
    return {
      currentIndex: 0,
      isApp: this.$root.$data.isApp || false,
      isMini: this.$root.miniprogram || false,
      benefits: [],
      // 用户会员等级
      userMemberInfo: {
        level: 0, // 0 普通用户 10 试用会员 20 普通会员 30 高级会员
        levelName: '普通用户',
        deadlineStartTime: null,
        deadlineEndTime: null, // 会员到期时间
        isTryoutMember: null, // 是否领取过试用会员
        beforeMemberLevel: null, // 上一次会员等级
      },
      activeTab: null,
      memberLevelInfo: {},
      memberLevel: {},
      key: 0,
      showBtn: 0,
    };
  },
  mounted() {
    if (this.$root.$data.isApp) {
      this.$sendToApp('getGIoVisitUserId', false);
    }
    window.setGIoVisitUserId = (value) => {
      this.getAndroid(value);
    };
    window['iqhApp2jsBridge.triggerSC'] = {};
    setTimeout(() => {
      // 获取登录状态
      window['iqhApp2jsBridge.triggerSC'].getLogin = this.getLogin;
      window['iqhApp2jsBridge.triggerSC'].reload = this.init;
    }, 100);
  },
  methods: {
    getPriceKey(level) {
      let key = 20;
      if ((this.activeTab === 20 && [20, 30].includes(level)) || this.activeTab === 30) {
        key = 30;
      }
      return key;
    },
    // 获取价格信息
    async setPriceInfo(allProductIds, key) {
      const endPoint = this.$root.$data.isApp ? 2 : 4;
      const memberLevelInfoTemp = JSON.parse(JSON.stringify(this.memberLevelInfo));
      const data = await reqCombinationlist(endPoint, allProductIds);
      const {
        packageDiscountRespVO, originalPrice, sellPrice,
      } = data[0];
      const { payPrice, promotionLabel, promotionEndTime } = packageDiscountRespVO;
      const priceInfo = {
        price: promotionLabel ? payPrice : sellPrice,
        originalPrice: promotionLabel ? originalPrice : '',
        endTime: promotionEndTime,
      };
      memberLevelInfoTemp[key].priceInfo = priceInfo;
      this.memberLevelInfo = memberLevelInfoTemp;
    },
    // 获取产品详情
    async setProductInfo(key, id) {
      const memberLevelInfoTemp = JSON.parse(JSON.stringify(this.memberLevelInfo));
      const responses = await reqCombinationDetail(id);
      let classType = '';
      const {
        packageId, packageProductRespList, faq, packageAttributeVOList,
      } = responses;
      const orderDetailArr = packageProductRespList.map((subItem) => {
        const { packageProductSkuWebRespList, productId } = subItem;
        const { skuId } = packageProductSkuWebRespList[0];
        const { dataJson } = packageAttributeVOList[0];
        classType = dataJson;
        return {
          productId,
          skuId,
          packageId,
        };
      });
      memberLevelInfoTemp[key].products = orderDetailArr;
      memberLevelInfoTemp[key].faq = faq;
      memberLevelInfoTemp[key].productIds = orderDetailArr.map((item) => item.productId);
      if (this.$root.miniprogram) {
        const types = await getClassType();
        const status = types.some((item) => item.value === classType);
        this.$root.setMiniProgramBuy(status);
      }
      this.memberLevelInfo = memberLevelInfoTemp;
    },
    // 生成订单
    generateOrder(level) {
      if (!this.userInfo.id) {
        if (this.isApp) {
          this.$sendToApp('login', {}, true);
        } if (this.$root.miniprogram) {
          let url = window.location.href;
          const [domain, searchParams] = url.split('?');
          const params = searchParams.split('&');
          if (params) {
            const paramsMap = new Map();
            params.forEach((item) => {
              const [key, value] = item.split('=');
              if (key) {
                paramsMap.set(key, value);
              }
            });
            const entries = paramsMap.entries();
            let query = '';
            const ExcludequeryArr = ['THIRD_SESSION', 'env'];
            // eslint-disable-next-line no-restricted-syntax
            for (const [key, value] of entries) {
              if (!ExcludequeryArr.includes(key)) query += `${key}=${value}&`;
            }
            url = `${domain}?${query}`;
          }
          const redirctUrl = encodeURIComponent(`/subPackages/customShareWebview/webView?url=${encodeURIComponent(url)}`);
          const path = `/subPackages/loginPage/loginPage?isHandle=1&isWebview=1&isCancelgoBack=1&redirctUrl=${redirctUrl}`;
          wx.miniProgram.redirectTo({
            url: path,
          });
        } else {
          const { path, query } = this.$route;
          this.$router.push({ path: '/registrationLogin', query: { redirect: path, ...query } });
        }
      } else {
        this.entryPayOrder(level);
      }
    },
    // 支付订单
    entryPayOrder(level) {
      const info = this.memberLevelInfo[level];
      const { packageId, products } = info;
      if (this.isApp) {
        this.$sendToApp('buyCourseNew', {
          product: JSON.stringify(products), packageId, miniBeforePageName: 8, level,
        }, false);
      } else if (this.$root.miniprogram) {
        const url = window.location.href;
        const [, searchParams] = url.split('?');
        const { origin } = window.location;
        let path = `${origin}/ark/payOrder?product=${JSON.stringify(products)}&packageId=${packageId}&miniBeforePageName=8&`;
        const params = searchParams.split('&');
        if (params) {
          const paramsMap = new Map();
          params.forEach((item) => {
            const [key, value] = item.split('=');
            if (key) {
              paramsMap.set(key, value);
            }
          });
          const entries = paramsMap.entries();
          let query = '';
          const ExcludequeryArr = ['THIRD_SESSION', 'env'];
          // eslint-disable-next-line no-restricted-syntax
          for (const [key, value] of entries) {
            if (ExcludequeryArr.includes(key) && value) query += `${key}=${value}&`;
          }
          path += query;
        }
        const jumpUrl = `/subPackages/webView/webView?url=${encodeURIComponent(path)}`;
        wx.miniProgram.navigateTo({
          url: jumpUrl,
        });
      } else {
        const miniBeforePageName = localStorage.getItem('miniBeforePageName');
        if (!miniBeforePageName) {
          localStorage.setItem('miniBeforePageName', 8);
        }
        this.$router.push({
          path: '/payOrder',
          query: {
            product: JSON.stringify(products),
            packageId,
          },
        });
      }
    },
    openChat() {
      if (this.isApp) {
        this.$sendToApp(
          'openNewWebView',
          {
            url: `https://iqihang.sobot.com/chat/h5/v2/index.html?sysnum=ba284951843a4490afb0719b16367967&channelid=3&partnerid=${this.userInfo.id || ''}`,
          },
          false,
        );
      } else if (this.$root.miniprogram) {
        wx.miniProgram.navigateTo({
          url: '/subPackages/zhichi/zhichi',
        });
      } else {
        window.open(
          `https://iqihang.sobot.com/chat/h5/v2/index.html?sysnum=ba284951843a4490afb0719b16367967&channelid=3&partnerid=${this.userInfo.id || ''}`,
        );
      }
    },
    getLogin(APPSESSION) {
      const cookieToken = APPSESSION;
      if ((window?.navigator?.userAgent || '').includes('iqihang')) {
        window.localStorage.setItem('accessToken', cookieToken || '');
        this.getLoginAfter();
      }
    },
    async getLoginAfter() {
      await this.$root.getUserInfo();
      this.init();
    },
    getAndroid(value) {
      if (this.$root.$data.isApp) {
        this.gioVisitUserId = `{u:'${value || ''}', roomId: '${this.$route.query.liveRoomId || ''}',wechatSource:'${this.miniParams()}'}`;
      }
    },
    // mode不要删除 不然会报错
    async init(mode) {
      const { activeTab, index } = this.$route.query;
      this.activeTab = Number(activeTab);
      const req = activeTab === '20' ? getBasicBenefits : getSeniorBenefits;
      this.$toast.loading({
        message: '加载中...',
        forbidClick: false,
        duration: 0,
      });
      const benefits = await req();
      this.benefits = benefits.map((item) => {
        const { value, remark } = item;
        const { title, icon } = JSON.parse(remark) || {};
        return {
          title,
          icon,
          faq: value,
        };
      });
      this.$nextTick(() => {
        this.currentIndex = Number(index);
      });
      let currentLevel = 0;
      if (this.userInfo.id) {
        const userMemberInfoTemp = await getUserMember();
        const {
          deadlineEndTime, level, productIds, ...rest
        } = userMemberInfoTemp;
        currentLevel = level;
        this.userMemberInfo = {
          ...rest,
          level,
          productIds,
          deadlineEndTime: deadlineEndTime?.split(' ')[0] || '',
        };
      }
      // 已购买高级会员的高级会员页面不展示购买按钮
      if (currentLevel === 30 && Number(activeTab) === 30) {
        this.$toast.clear();
        return;
      }
      const key = this.getPriceKey(currentLevel);
      this.key = key;
      const memberLevelInfoTemp = JSON.parse(JSON.stringify(this.memberLevelInfo));
      // 获取会员等级相关信息
      const MemberLevelInfo = await getMemberLevelInfo();
      // const packageIdToMemberLevel = {};
      // const btnMap = {
      //   10: 'showTrialBtn',
      //   20: 'showBasicBtn',
      //   30: 'showSeniorBtn',
      // };
      let showBtn = 1;
      const allProductIds = MemberLevelInfo?.filter((item) => {
        if (item.memberLevel === key) {
          memberLevelInfoTemp[key] = {
            packageId: item.packageId,
            number: item.number,
          };
        }
        showBtn = 2;
        return item.memberLevel === key;
      }).map((item) => item.packageId);
      this.memberLevelInfo = memberLevelInfoTemp;
      this.showBtn = showBtn;
      this.$toast.clear();
      if (showBtn === 2) {
        await this.setPriceInfo(allProductIds, key);
        await this.setProductInfo(key, allProductIds[0]);
      }
    },
  },
  async created() {
    this.init();
  },

};
</script>

<style lang="scss" scoped>
.box {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 750px;
}

.member__top {
  height: 100px;
}

::v-deep .van-tabs__line {
  display: none;
}

.van-tabs {
  flex: 1;
  height: 0;
  display: flex;
  flex-direction: column;
}

::v-deep .van-tabs--line .van-tabs__wrap {
  height: 94px;
}

::v-deep .van-tabs--line .van-tabs__content {
  flex: 1;
  height: 0;
}

::v-deep .van-tabs--line .van-tabs__content .van-tab__pane {
  height: calc(100% - 22px);
  background: rgba(247, 248, 252, 1);
}

::v-deep .van-tabs__wrap--scrollable .van-tab {}

::v-deep  .van-tab--active {
  .benefits__nav-title {
    color: #FF7F41;
  }
}

::v-deep .van-tabs--line .van-tabs__content .benefits__content {
  height: 100%;
  margin-top: 22px;
  background-color: #fff;
  padding: 36px 36px 85px;
  overflow: scroll;

  img {
    max-width: 100%;
  }
}

.benefits__nav {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &-img {
    width: 72px;
    height: 72px;
  }

  &-title {
    font-size: 22px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 31px;
    margin-top: 11px;
  }
}
</style>
